<template>
  <div id="annotate-tools">
    <div id="close" :class="{ showing: showWarning }">
      <div v-show="showWarning" id="close-warning">
        <span>You have unsaved changes</span>
        <div>
          <a href="#" @click="showWarning = false">cancel</a>
          <a href="#" @click="forceClose">close</a>
        </div>
      </div>
      <a href="#" v-show="!showWarning" id="close-button" @click="close">
        <img :src="require('images/close.svg')" />
      </a>
    </div>
    <div id="tools">
      <a class="tool" :class="{ active: tool == selectedTool, free: freeUser }" :key="tool" v-for="tool in tools" :id="tool" v-html="toolImage(tool)" @click="selectTool(tool)" />

      <div id="color-thickness">
        <div id="color-picker-trigger" ref="colorPickerTrigger" :style="{ background: selectedColor }" @click="openPicker('color')" data-toggle="tooltip" data-placement="top" title="change color">
        </div>

        <div id="thickness-picker-trigger" ref="thicknessPickerTrigger"  @click="openPicker('thickness')" data-toggle="tooltip" data-placement="top" title="change thickness">
          <span id="selected-thickness" :style="{ height: `${selectedThickness}px` }" />
        </div>

        <div id="font-size-picker-trigger" ref="fontSizePickerTrigger" @click="openPicker('font-size')" data-toggle="tooltip" data-placement="top" title="change font size">
          <div id="selected-font-size">
            {{ selectedFontSize }}
          </div>
        </div>

        <div
            id="color-picker"
            class="popup"
            v-if="selectColorOpen"
            v-closable="{
              exclude: ['colorPickerTrigger'],
              handler: 'onCloseBtnColorPicker'
            }"
            >
            <div id="color-list">
              <div class="color-swatch" v-for="color in colors" :key="color" :style="{ background: color }" @click="selectColor({ hex: color })">
              </div>
            </div>
            <div id="outline-input">
              <div>
                <input name="outline" id="outline" type="checkbox" v-model="outlineText" @change="changeOutline"/>
                <label for="outline">Outline text</label>
              </div>
              <div id="annotate-custom-color">
                <color-input
                  field_name="annotateCustomColor"
                  :value="selectedColor"
                  v-on:toggle:picker="customColorOpen = !customColorOpen"
                  testid="annotate-custom-color">
                </color-input>
              </div>
            </div>
            <chrome-picker id="custom-color"
              v-if="customColorOpen"
              :disable-fields="true"
              :disable-alpha="true"
              :value="selectedColor"
              @input="selectColor"
              ></chrome-picker>
        </div>

        <div
          id="thickness-picker"
          class="popup"
          v-if="selectThicknessOpen"
          v-closable="{
            exclude: ['thicknessPickerTrigger'],
            handler: 'onCloseBtnThicknessPicker'
          }"
          >
          <div class="thickness-swatch" v-for="thick in thickness" :key="thick" @click="selectThickness(thick)">
            <span :style="{ height: `${thick}px` }" />
          </div>
        </div>

        <div
          id="font-size-picker"
          class="popup"
          v-if="selectFontSizeOpen"
          v-closable="{
            exclude: ['fontSizePickerTrigger'],
            handler: 'onCloseBtnFontSizePicker'
          }"
          >
          <div class="font-size-swatch" v-for="fontsize in fontSize" :key="fontsize" @click="selectFontSize(fontsize)">
            {{ fontsize }}
          </div>
        </div>
      </div>
    </div>

    <div>
      <img v-show="uploading" :src="require('images/spinner.svg')"/>
      <a v-show="!uploading" href="#" id="save" @click="upload">
        Save
      </a>
    </div>
  </div>
</template>

<script>
  import EventBus from '../event_bus';
  import ColorInput from './color_input';

  export default {
    props: {
      selectedColor: {
        type: String
      },
      selectedTool: {
        type: String
      },
      selectedThickness: {
        type: Number
      },
      selectedFontSize: {
        type: Number
      },
      uploading: {
        type: Boolean
      },
      freeUser: {
        type: Boolean
      }
    },
    data: () => {
      let colors = ["#FF6191", "#C4FA13", "#39D5FE", "#222222","#FFE703", "#66F5E0", "#FFFFFF", "#00CC00"];
      let tools = ['arrow', 'line', 'draw', 'highlighter', 'ellipse', 'rect', 'crop', 'pixelate', 'text'];
      let thickness = [2,4,6];
      let fontSize = [20,40,60];
      return {
        tools,
        colors,
        thickness,
        fontSize,
        customColorOpen: false,
        selectColorOpen: false,
        selectThicknessOpen: false,
        selectFontSizeOpen: false,
        selectOpen: false,
        outlineText: true,
        dirty: false,
        showWarning: false,
      }
    },
    mounted() {
      let vm = this;
      EventBus.$on('toggle:picker:annotateCustomColor', () => vm.customColorOpen = true)
      EventBus.$on('annotate:dirty', () => vm.dirty = true)
      EventBus.$on('annotate:clean', () => vm.dirty = false)
    },
    methods: {
      close: function() {
        if(this.dirty){
          this.showWarning = true;
        } else {
          EventBus.$emit('annotate:close');
        }
      },
      forceClose: function(){
        this.showWarning = false;
        this.dirty = false;
        this.close();
      },
      upload: () => EventBus.$emit('annotate:upload'),
      selectTool: function(tool) {
        if(tool == 'highlighter' && this.freeUser) {
          window.location.href = `/plans?utm_source=viewer&utm_campaign=upgrade&utm_medium=${tool}`;
          return;
        }

        EventBus.$emit('annotate:selectTool', tool)
        localStorage.setItem('annotate:selectedTool', tool)
      },
      toolImage: (tool) => require(`!html-loader!images/annotate/${tool}.svg`),
      changeOutline: function() { EventBus.$emit('annotate:outlineText', this.outlineText) },
      closePickers: function() {
        this.selectColorOpen = false;
        this.selectThicknessOpen = false;
        this.selectFontSizeOpen = false;
      },
      onCloseBtnColorPicker: function(){
        this.selectColorOpen = false;
      },
      onCloseBtnThicknessPicker: function(){
        this.selectThicknessOpen = false;
      },
      onCloseBtnFontSizePicker: function(){
        this.selectFontSizeOpen = false;
      },
      openPicker: function(picker) {
        this.selectColorOpen = picker == "color";
        this.selectThicknessOpen = picker == "thickness";
        this.selectFontSizeOpen = picker == "font-size";
      },
      selectColor: function(color) {
        EventBus.$emit('annotate:selectColor', color.hex);
        localStorage.setItem('annotate:selectedColor', color.hex);
      },
      selectThickness: function(thickness) {
        // Unless color selector, this is closed as soon as is picked.
        EventBus.$emit('annotate:selectThickness', thickness);
        localStorage.setItem('annotate:selectedThickness', thickness);
        this.selectThicknessOpen = false;
      },
      selectFontSize: function(fontSize) {
        // Unless color selector, this is closed as soon as is picked.
        EventBus.$emit('annotate:selectFontSize', fontSize);
        localStorage.setItem('annotate:selectedFontSize', fontSize);
        this.selectFontSizeOpen = false;
      },
    },
    components: { ColorInput }
  }
</script>

<style lang="scss" scoped>
  label { margin: 0; }

  #annotate-tools {
    border-bottom: 1px solid #d8d8d8;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
    height: 62px;
  }

  #close {
    position: relative;
    min-width: 16px;
    &.showing {
      min-width: 142px;
    }
  }

  #close-warning {
    display: flex;
    flex-direction: column;
    width: 142px;
    top: -20px;

    span {
      font-size: 12px;
    }

    div {
      display: flex;
      justify-content: space-around;
    }
  }

  #tools {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #emoji img { width: 16px; }

  #color-thickness {
    border: solid 1px #c2c2c2;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 2rem;
    width: 8rem;
    border-radius: 16px;
    position: relative;
  }

  #color-picker-trigger {
    cursor: pointer;
    width: 1.25rem;
    height: 1.25rem;
    border: solid 2px #f0f0f0;
    border-radius: 1rem;

    &:hover {
      border-color: #c2c2c2;
    }
  }

  #outline-input {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 10px 0;
  }

  #annotate-custom-color {
    width: 110px;
  }

  #custom-color {
    width: 100%;
  }

  #highlighter {
    &.free {
      background: url('~images/pro-ribbon.png') no-repeat;
      background-size: 26px;
    }
  }

  .popup {
    position: absolute;
    top: 35px;
    left: 0;
    background: #fff;
    border: 1px solid #c2c2c2;
    border-radius: 4px;
    padding: 10px;
    z-index: 1;
  }

  #color-list {
    width: 230px;
    display: flex;
    flex-wrap: wrap;
  }

  .color-swatch {
    width: 55px;
    height: 35px;
    margin: 1px;
    border: 1px solid #c2c2c2;
    cursor: pointer;
  }

  .thickness-swatch {
    width: 58px;
    height: 26px;
    margin: 5px 0px;
    background: #f0f0f0;
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      border-color: #c2c2c2;
    }

    span {
      display: inline-block;
      width: 70%;
      background: black;
    }
  }

  #thickness-picker-trigger {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 2.75rem;
    height: 1.5rem;
    background: #f0f0f0;
    border: 2px solid #f0f0f0;
    border-radius: 1rem;
    position: relative;

    &:hover {
      border-color: #c2c2c2;
    }
  }

  #selected-thickness {
    width: 70%;
    border-radius: 1rem;
    background: #4A4A4A;
  }

  .font-size-swatch {
    width: 58px;
    height: 26px;
    margin: 5px 0px;
    background: #f0f0f0;
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      border-color: #c2c2c2;
    }

    span {
      display: inline-block;
      width: 70%;
      background: black;
    }
  }

  #font-size-picker-trigger {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 2.75rem;
    height: 1.5rem;
    background: #f0f0f0;
    border: 2px solid #f0f0f0;
    border-radius: 1rem;
    position: relative;

    &:hover {
      border-color: #c2c2c2;
    }
  }

  #selected-font-size {
    width: 70%;
    border-radius: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #save {
    align-items: center;
    background-color: #007AFF;
    border-radius: 4px;
    color: #FFF;
    display: flex;
    height: 2rem;
    justify-content: center;
    text-decoration: none;
    width: 4rem;
  }

  .tool {
    border: solid 1px #c2c2c2;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    padding: 10px;
    margin: 0 .5rem;

    &.active {
      border: solid 1px #007AFF;
      background: #007AFF;
    }

    &.disabled {
      background: #f0f0f0;
    }
  }
</style>


<style lang="scss">
  /* global overrides */
  #annotate-tools {
    .tool {
      path {
        fill: #4A4A4A;
      }

      &:hover path {
        fill: #007AFF;
      }

      &.disabled:hover path {
        fill: #4A4A4A;
      }

      &.active path {
        fill: #FFF;
      }
    }

    #pixelate {
      &:hover g{ filter: invert(100%) url(#pixelate-blue); }
      &.active g{ filter: invert(100%) url(#pixelate-white); }
    }
  }


  #annotate-custom-color {
    .form-control {
      padding: 0 10px;
      height: 30px;
    }

    .custom-input-color-icon {
      top: 7px;
    }
  }
</style>
